var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"scientific-free-response"}},_vm._l((_vm.parseAnswerObject()),function(item,index){return _c('div',{key:index,staticClass:"scientific-respone-container"},[_c('label',{staticClass:"answer-category"},[_vm._v(_vm._s(item.category))]),_c('span',{domProps:{"innerHTML":_vm._s(item.value)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }